module.exports = __webpack_public_path__ + "static/media/WorcesterBackground2.d51b4ec1.jpg";